import * as types from "../mutation-types";
import axios from "axios";
import Vue from "vue";
import { fetcher } from "../../utils";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

// state
export const state = {
    default_colors: [
        "#FF6633",
        "#FF33FF",
        "#FFFF99",
        "#00B3E6",
        "#E6B333",
        "#3366E6",
        "#999966",
        "#99FF99",
        "#B34D4D",
        "#80B300",
        "#809900",
        "#E6B3B3",
        "#6680B3",
        "#66991A",
        "#FF99E6",
        "#CCFF1A",
        "#FF1A66",
        "#66994D",
        "#B366CC",
        "#4D8000",
        "#B33300",
        "#CC80CC",
        "#66664D",
        "#991AFF",
        "#E666FF",
        "#4DB3FF",
        "#1AB399",
        "#E666B3",
        "#33991A",
        "#E6331A",
        "#CC9999",
        "#B3B31A",
        "#00E680",
        "#4D8066",
        "#809980",
        "#E6FF80",
        "#1AFF33",
        "#999933",
        "#FF3380",
        "#CCCC00",
        "#66E64D",
        "#4D80CC",
        "#9900B3",
        "#E64D66",
        "#4DB380",
        "#FF4D4D",
        "#99E6E6",
        "#6666FF",
    ],

    send_form: {},

    /* To dismiss */
    table_data: [],
    chart_data: [],
    data: [],

    fields: [],
    plugins: [],
    triggerPlugins: [],
    triggerEvents: [],
    pluginIntegrations: [],

    languages: [],
    countries: [],
    fields: [],
    fieldsAdvance: [],
    fieldsAdvanceIndexById: {},
    subTags: [],
    balancingShipmentTypes: [],

    requestCancelToken: source,
};

// getters
export const getters = {
    default_colors: (state) => state.default_colors,
    send_form: (state) => state.send_form,
    fields: (state) => state.fields,
    plugins: (state) => state.plugins,
    pluginIntegrations: (state) => state.pluginIntegrations,
    triggerPlugins: (state) => state.triggerPlugins,
    triggerEvents: (state) => state.triggerEvents,
    languages: (state) => state.languages,
    countries: (state) => state.countries,
    fields: (state) => state.fields,
    fieldsAdvance: (state) => state.fieldsAdvance,
    fieldsAdvanceIndexById: (state) => state.fieldsAdvanceIndexById,
    subTags: (state) => state.subTags,
    balancingShipmentTypes: (state) => state.balancingShipmentTypes,
    requestCancelToken: (state) => state.requestCancelToken,

    /* To dismiss */
    table_data: (state) => state.table_data,
    chart_data: (state) => state.chart_data,
    data: (state) => state.data,
};

// mutations
export const mutations = {
    [types.SEND_FORM](state, { data }) {
        Vue.set(state, "send_form", data);
    },

    [types.FIELDS](state, { fields }) {
        Vue.set(state, "fields", fields);
    },

    [types.PLUGINS](state, { plugins }) {
        Vue.set(state, "plugins", plugins);
    },

    [types.PLUGIN_INTEGRATIONS](state, { pluginIntegrations }) {
        Vue.set(state, "pluginIntegrations", pluginIntegrations);
    },

    [types.TRIGGER_EVENTS](state, { triggerEvents }) {
        Vue.set(state, "triggerEvents", triggerEvents);
    },

    [types.TRIGGER_PLUGINS](state, { triggerPlugins }) {
        Vue.set(state, "triggerPlugins", triggerPlugins);
    },

    [types.LANGUAGES](state, { languages }) {
        Vue.set(state, "languages", languages);
    },

    [types.COUNTRIES](state, { countries }) {
        Vue.set(state, "countries", countries);
    },

    [types.FIELDS](state, { fields }) {
        Vue.set(state, "fields", fields);
    },

    [types.FIELDS_ADVANCE](state, { fields }) {
        Vue.set(state, "fieldsAdvance", fields);
    },

    [types.FIELDS_ADVANCE_INDEX_BY_ID](state, { fields }) {
        Vue.set(state, "fieldsAdvanceIndexById", fields);
    },

    [types.SUB_TAGS](state, { subTags }) {
        Vue.set(state, "subTags", subTags);
    },
    [types.BALANCING_SHIPMENT_TYPES](state, { balancingShipmentTypes }) {
        Vue.set(state, "balancingShipmentTypes", balancingShipmentTypes);
    },

    [types.REQUEST_CANCEL_TOKEN](state, { requestCancelToken }) {
        Vue.set(state, "requestCancelToken", requestCancelToken);
    },

    /* To dismiss */
    [types.LOAD_TABLE_DATA](state, { table_data }) {
        Vue.set(state, "table_data", table_data);
    },
    /* To dismiss */
    [types.LOAD_CHART_DATA](state, { chart_data }) {
        Vue.set(state, "chart_data", chart_data);
    },
    /* To dismiss */
    [types.LOAD_DATA](state, { data }) {
        Vue.set(state, "data", data);
    },
};

// actions
export const actions = {
    /**
     * @function sendForm
     * @param {*} url
     * @param {*} identifier
     * @param {*} form
     * @param {*} method
     * @description Send a object with the date of the form
     */
    /* To update change host for url */
    async sendForm({ commit, state }, payload) {
        let form = payload.form;
        let url = payload.url;
        let method = payload.method;
        let identifier = payload.identifier;

        /* if(identifier && (method == "put" || method == "PUT")){
            url = url+"/"+identifier
        } */
        if (identifier) {
            url = url + "/" + identifier;
        }

        const axios_config = {
            url: url,
            method: method,
            data: form,
        };

        try {
            const { data } = await axios(axios_config);
            commit(types.SEND_FORM, { data });
        } catch (error) {
            throw error;
        }
    },

    async loadTableData({ commit, state }, payload) {
        let host = payload.host;
        let rows = payload.rows;
        let page = payload.page;
        let query = payload.query;

        const axios_config = {
            url: host,
            method: "get",
            params: {
                rows,
                page,
                query,
            },
        };

        try {
            const { data } = await axios(axios_config);
            commit(types.LOAD_TABLE_DATA, { table_data: data });
        } catch (error) {
            console.log(error);
        }
    },

    async loadChartData({ commit, state }, payload) {
        let host = payload.host;
        let queries = payload.queries;
        let chart_data = [];

        let axios_config = {
            url: host,
            method: "get",
            params: {
                query: {},
            },
        };
        try {
            for (let i = 0; i < queries.length; i++) {
                const query = queries[i];
                axios_config.params.query = query;
                const { data } = await axios(axios_config);
                chart_data.push(data);
            }
            commit(types.LOAD_CHART_DATA, { chart_data });
        } catch (error) {
            console.log(error);
        }
    },

    async getQuery({ commit, state }, payload) {
        const url = payload.url;
        const query = payload.query;

        const axios_config = {
            url: url,
            method: "get",
            params: {
                query: query,
            },
        };
        try {
            const { data } = await axios(axios_config);
            commit(types.LOAD_DATA, { data: data });
        } catch (e) {
            console.log(e);
        }
    },

    async loadScript({ commit, state }, payload) {
        let src = payload.src;
        if (src) {
            await Vue.loadScript(src);
        }
    },

    async saveFields({ commit, state }, payload) {
        commit(types.FIELDS, { fields: payload.fields });
    },

    async savePlugins({ commit, state }, payload) {
        commit(types.PLUGINS, { plugins: payload.plugins });
    },

    async saveTriggerEvents({ commit, state }, payload) {
        commit(types.TRIGGER_EVENTS, { triggerEvents: payload.triggerEvents });
    },

    restoreDefaultTriggerEvents({ commit }) {
        commit(types.TRIGGER_EVENTS, { triggerEvents: [] });
    },

    async saveTriggerPlugins({ commit, state }, payload) {
        commit(types.TRIGGER_PLUGINS, {
            triggerPlugins: payload.triggerPlugins,
        });
    },

    restoreDefaultTriggerPlugins({ commit }) {
        commit(types.TRIGGER_PLUGINS, { triggerPlugins: [] });
    },

    async savePluginIntegrations({ commit, state }, payload) {
        commit(types.PLUGIN_INTEGRATIONS, {
            pluginIntegrations: payload.pluginIntegrations,
        });
    },

    restoreDefaultPluginIntegrations({ commit }) {
        commit(types.PLUGIN_INTEGRATIONS, { pluginIntegrations: [] });
    },

    restoreDefaultGlobalStore({ dispatch }) {
        dispatch("restoreDefaultPluginIntegrations");
        dispatch("restoreDefaultTriggerPlugins");
        dispatch("restoreDefaultTriggerEvents");
    },

    async saveLanguages({ commit, state }, payload) {
        commit(types.LANGUAGES, { languages: payload.languages });
    },

    async saveCountries({ commit, state }, payload) {
        commit(types.COUNTRIES, { countries: payload.countries });
    },

    async saveFields({ commit, state }, payload) {
        commit(types.FIELDS, { fields: payload.fields });
    },

    async saveFieldsAdvance({ commit, state }, payload) {
        commit(types.FIELDS_ADVANCE, { fields: payload.fields });
    },

    async saveFieldsAdvanceIndexById({ commit, state }, payload) {
        commit(types.FIELDS_ADVANCE_INDEX_BY_ID, { fields: payload.fieldsIndexById });
    },

    async saveSubTags({ commit, state }, payload) {
        commit(types.SUB_TAGS, { subTags: payload.subTags });
    },

    async saveRequestCancelToken({ commit, state }, payload) {
        commit(types.REQUEST_CANCEL_TOKEN, {
            requestCancelToken: payload.requestCancelToken,
        });
    },

    async getBalancingShipmentTypes({ commit, state }, payload) {
        let data = await fetcher({ url: "/shipment.balancing.api/types" });
        commit(types.BALANCING_SHIPMENT_TYPES, {
            balancingShipmentTypes: data._items,
        });
    },
};
